
import { IconProps } from '../../../lib/types';

const LocationAlt: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="27.038"
      height="35.628"
      viewBox="0 0 27.038 35.628"
    >
      <path
        d="M8.095 13.519a5.425 5.425 0 115.425 5.425 5.423 5.423 0 01-5.425-5.425zm5.425-4.34a4.34 4.34 0 104.34 4.34 4.344 4.344 0 00-4.341-4.34zm13.019 4.34c0 5.926-7.934 16.477-11.412 20.831a2.049 2.049 0 01-3.214 0C8.373 30 .5 19.446.5 13.519a13.019 13.019 0 0126.038 0zM13.519 1.585A11.934 11.934 0 001.585 13.519a12.9 12.9 0 001.208 4.719 43.133 43.133 0 003.031 5.716 111.076 111.076 0 006.935 9.717.962.962 0 001.519 0 111.338 111.338 0 006.937-9.717 43.535 43.535 0 003.031-5.716 12.961 12.961 0 001.207-4.719A11.934 11.934 0 0013.519 1.585z"
        className="a"
      ></path>
    </svg>
  );
};

export default LocationAlt;